import React, { useEffect, useState } from "react";
import logo from "../../assets/Icons/logo.png";
// import img from "../../assets/login_img.png"
import { useNavigate } from "react-router-dom";
import eye from "../../assets/Icons/eye-off.png";
import "./auth.css";
import { AUTENTICATE_API } from "../../services/apiCalls/authApi";
import { toast } from "react-toastify";

const Login = () => {
  const navigate = useNavigate();
  const [userIDErr, setuserIDErr] = useState("");
  const [userIDErrFlag, setuserIDErrFlag] = useState(false);
  const [userID, setuserID] = useState("");
  const [passwordErrFlag, setpasswordErrFlag] = useState(false);
  const [passwordErr, setpasswordErr] = useState(false);
  const [password, setpassword] = useState("");

  const onLogin = async (e) => {
    e.preventDefault();

    function validateEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    }

    if (userID == "" && password == "") {
      setpasswordErrFlag(true);
      setuserIDErrFlag(true);
      return false;
    }
    if (userID == "") {
      setuserIDErrFlag(true);
      return false;
    }
    if (!validateEmail(userID)) {
      setuserIDErrFlag(true);
      return false;
    }
    if (password == "") {
      setpasswordErrFlag(true);
      return false;
    }
    let obj = {
      username: userID,
      password: password,
      grant_type: "password",
    };
    const userLogin = await AUTENTICATE_API.customerLogin(obj);

    if (userLogin && userLogin.Status === "200") {
      const { access_token, Name, Email, Role, profile_img, user_id, Message } =
        userLogin;

      const obj = {
        user: {
          Name,
          Email,
          Role,
          user_id,
          profile_img,
          password,
        },
        token: access_token,
      };
      localStorage.setItem("state", JSON.stringify(obj));
      toast.success(Message, { autoClose: 2000 });
      setTimeout(() => {
        localStorage.setItem("tab", "MyProjects");
        if (obj.user.user_id != 1 && obj.user.user_id != 2) {
          navigate("/my-tasks");
        } else {
          navigate("/my-projects");
        }
      }, 2500);
    } else {
      //   toast.error("Login failed. Please check your credentials.");
    }
  };

  useEffect(() => {}, []);

  function isAlphanumeric(str) {
    let rg = /^[a-zA-Z0-9]+$/;
    return rg.test(str);
  }

  return (
    <React.Fragment>
      <div className="container mt-5" style={{ textAlign: "center" }}>
        <img src={logo} style={{ width: 140 }} />
      </div>
      <div className="container">
        <section className="s" style={{ marginTop: "0px" }}>
          <div className="container mt-2">
            <div className="row justify-content-center">
              {/* <div className=' col-lg-5 col-12 order-2 d-none d-lg-block order-lg-2'>
                            <img src={logo} className='' style={{ width: "100%", height: 600, margin: "auto" }} />
                        </div> */}
              <div className=" col-lg-5 col-12 order-1 order-lg-1 my-auto right-bar">
                <>
                  <div className="p-4">
                    <div className="col-12 my-0">
                      <div
                        style={{
                          fontSize: 30,
                          fontWeight: 600,
                          color: "#313131",
                        }}
                      >
                        Login
                      </div>
                      <div
                        style={{
                          fontSize: 16,
                          fontWeight: 400,
                          color: "#313131",
                        }}
                      >
                        Login to access your account
                      </div>
                    </div>
                    <form onSubmit={onLogin}>
                      <div className="my-2">
                        <input
                          className="form-control shadow-none p-2 form-control-custome"
                          value={userID}
                          onChange={(e) => {
                            setuserIDErrFlag(false);
                            setuserID(e.target.value);
                          }}
                          id={`${userIDErrFlag === true ? "errr" : ""}`}
                          type="text"
                          placeholder="Email"
                        />
                        <br />

                        <div className="position-relative">
                          <input
                            className="form-control shadow-none p-2 con-passwords form-control-custome"
                            value={password}
                            onChange={(e) => {
                              setpasswordErrFlag(false);
                              setpassword(e.target.value);
                            }}
                            id={`${passwordErrFlag === true ? "errr" : ""}`}
                            placeholder="Password"
                            type="password"
                          />
                          <img
                            onClick={() => {
                              let types =
                                document.getElementsByClassName(
                                  "con-passwords"
                                )[0];
                              if (types.type === "password") {
                                types.type = "text";
                              } else {
                                types.type = "password";
                              }
                            }}
                            src={eye}
                            className="eye"
                          />
                        </div>

                        <div className="d-flex justify-content-between mb-4 mt-3">
                          <div className="form-check">
                            <input
                              className="form-check-input shadow-none"
                              type="checkbox"
                              value=""
                              id="flexCheckDefault"
                            />
                            <label
                              className="form-check-label"
                              for="flexCheckDefault"
                            >
                              Remember me
                            </label>
                          </div>
                          {/* <a onClick={() => {
                                                navigate("/forgot-password")
                                            }} style={{ color: '#FF8682', fontSize: 15, fontWeight: 500, cursor: 'pointer' }}>Forgot password?</a> */}
                        </div>
                        <button
                          onClick={onLogin}
                          className="mb-4 custom-form w-100"
                        >
                          Login
                        </button>
                      </div>
                    </form>
                  </div>
                </>
              </div>
            </div>
          </div>
        </section>
      </div>
    </React.Fragment>
  );
};

export default Login;
